import store from '@/store'

export const checkIsZoomApp = () => {
  if (window.location.href.includes('zoomApp')) {
    store.dispatch('zoomApp/setIsZoomAppAction', true)
  }
}
